import type { DefaultTheme } from 'styled-components';

import Icons from '../../Elements/Icons/index.ts';
import type { InfoTooltipIconType } from './types.ts';

export const getIconConfig = (type: InfoTooltipIconType, colors: DefaultTheme['colors']) => {
  switch (type) {
    case 'info':
      return { Icon: Icons.Info, color: colors.grey70_1 };
    case 'warning':
      return { Icon: Icons.Warning, color: colors.warning100 };
    case 'payment':
      return { Icon: Icons.Dollar, color: colors.critical100 };
    default:
      return null;
  }
};
